// source: pbtypes/gen/cellular_sim_configs/fn920_config.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_cellular_sim_configs_sim_config_override_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_config_override_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_config_override_pb);
goog.exportSymbol('proto.cellular_sim_configs.Fn920Config', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cellular_sim_configs.Fn920Config = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cellular_sim_configs.Fn920Config, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cellular_sim_configs.Fn920Config.displayName = 'proto.cellular_sim_configs.Fn920Config';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cellular_sim_configs.Fn920Config.prototype.toObject = function(opt_includeInstance) {
  return proto.cellular_sim_configs.Fn920Config.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cellular_sim_configs.Fn920Config} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.Fn920Config.toObject = function(includeInstance, msg) {
  var f, obj = {
fwswitch: jspb.Message.getFieldWithDefault(msg, 1, 0),
imsEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
override: (f = msg.getOverride()) && pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cellular_sim_configs.Fn920Config}
 */
proto.cellular_sim_configs.Fn920Config.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cellular_sim_configs.Fn920Config;
  return proto.cellular_sim_configs.Fn920Config.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cellular_sim_configs.Fn920Config} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cellular_sim_configs.Fn920Config}
 */
proto.cellular_sim_configs.Fn920Config.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFwswitch(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setImsEnabled(value);
      break;
    case 3:
      var value = new pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride.deserializeBinaryFromReader);
      msg.setOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cellular_sim_configs.Fn920Config.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cellular_sim_configs.Fn920Config.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cellular_sim_configs.Fn920Config} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cellular_sim_configs.Fn920Config.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFwswitch();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getImsEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOverride();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 fwswitch = 1;
 * @return {number}
 */
proto.cellular_sim_configs.Fn920Config.prototype.getFwswitch = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cellular_sim_configs.Fn920Config} returns this
 */
proto.cellular_sim_configs.Fn920Config.prototype.setFwswitch = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool ims_enabled = 2;
 * @return {boolean}
 */
proto.cellular_sim_configs.Fn920Config.prototype.getImsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cellular_sim_configs.Fn920Config} returns this
 */
proto.cellular_sim_configs.Fn920Config.prototype.setImsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional SimConfigOverride override = 3;
 * @return {?proto.cellular_sim_configs.SimConfigOverride}
 */
proto.cellular_sim_configs.Fn920Config.prototype.getOverride = function() {
  return /** @type{?proto.cellular_sim_configs.SimConfigOverride} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_sim_config_override_pb.SimConfigOverride, 3));
};


/**
 * @param {?proto.cellular_sim_configs.SimConfigOverride|undefined} value
 * @return {!proto.cellular_sim_configs.Fn920Config} returns this
*/
proto.cellular_sim_configs.Fn920Config.prototype.setOverride = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cellular_sim_configs.Fn920Config} returns this
 */
proto.cellular_sim_configs.Fn920Config.prototype.clearOverride = function() {
  return this.setOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cellular_sim_configs.Fn920Config.prototype.hasOverride = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.cellular_sim_configs);
